export default __webpack_public_path__ + "static/media/kid3.f9e409e1.png";